import { render, staticRenderFns } from "./updateTipPercent.vue?vue&type=template&id=3742ef87&"
import script from "./updateTipPercent.vue?vue&type=script&lang=ts&"
export * from "./updateTipPercent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports